import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Container,
  Stack,
  Typography,
  TextField,
  TextareaAutosize,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  CardActionArea,
} from "@common-ui/ui";
import { ClientProfile } from "../../components/ScopingHeader/CustomerPlaceDetails/ClientProfile";
import { PlaceProfile } from "../../components/ScopingHeader/CustomerPlaceDetails/PlaceProfile";

export const CreateWorkEvent = ({
  formik,
  customer,
  places,
  setOpenCustomerPlaceDialog,
}) => {
  return (
    <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
      <form onSubmit={formik.handleSubmit}>
        <Card sx={{ mt: 2, padding: 2 }} variant="outlined">
          <CardActionArea
            onClick={() => {
              setOpenCustomerPlaceDialog(true);
            }}
          >
            <CardContent>
              <Grid container spacing={2} columns={{ xs: 8, md: 12 }}>
                <Grid item md={6} xs={12}>
                  <ClientProfile clientProfile={customer} />
                </Grid>
                <Grid item md={6} xs={12} mt={{ xs: 2, md: 0 }}>
                  <PlaceProfile placeProfile={places} />
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Card>
        <Grid container spacing={3}>
          <Grid item md={8} xs={12} mb={{ xs: 1, md: 5 }}>
            <Card sx={{ mt: 2, padding: 2 }} variant="outlined">
              <CardHeader title="Work Event Details" />
              <CardContent>
                <Grid container spacing={2} columns={{ xs: 8, md: 16 }}>
                  <Grid item xs={12} md={8}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography fontSize={12} variant="h4" fontWeight="700">
                        Reference Work Order ID
                      </Typography>
                    </Stack>
                    <TextField
                      id="work_order_reference"
                      sx={{ mt: 1 }}
                      size="small"
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.work_order_reference &&
                          formik.errors.work_order_reference
                      )}
                      fullWidth
                      helperText={
                        formik.touched.work_order_reference &&
                        formik.errors.work_order_reference
                      }
                      placeholder="Reference Work Order ID"
                      margin="normal"
                      name="work_order_reference"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      type="text"
                      value={formik.values.work_order_reference}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography
                        fontSize={12}
                        variant="h4"
                        fontWeight="700"
                        sx={{ mb: 1 }}
                      >
                        Scheduled Start Date
                      </Typography>
                    </Stack>
                    <DatePicker
                      isClearable
                      showMonthDropdown
                      showYearDropdown
                      todayButton="Today"
                      dropdownMode="select"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Start date"
                      selected={formik.values.scheduled_start_date}
                      onChange={(date) =>
                        formik.setFieldValue("scheduled_start_date", date)
                      }
                      customInput={
                        <TextField
                          fullWidth
                          size="small"
                          name="scheduled_start_date"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.scheduled_start_date}
                          error={Boolean(
                            formik.touched.scheduled_start_date &&
                              formik.errors.scheduled_start_date
                          )}
                          helperText={
                            formik.touched.scheduled_start_date &&
                            formik.errors.scheduled_start_date
                          }
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography fontSize={12} variant="h4" fontWeight="700">
                        Client Purchase Order
                      </Typography>
                    </Stack>
                    <TextField
                      id="purchase_order_reference"
                      sx={{ mt: 1 }}
                      size="small"
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.purchase_order_reference &&
                          formik.errors.purchase_order_reference
                      )}
                      fullWidth
                      helperText={
                        formik.touched.purchase_order_reference &&
                        formik.errors.purchase_order_reference
                      }
                      placeholder="Client Purchase Order"
                      margin="normal"
                      name="purchase_order_reference"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      type="text"
                      value={formik.values.purchase_order_reference}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography
                        fontSize={12}
                        variant="h4"
                        fontWeight="700"
                        sx={{ mb: 1 }}
                      >
                        Scheduled End Date
                      </Typography>
                    </Stack>
                    <DatePicker
                      isClearable
                      showMonthDropdown
                      showYearDropdown
                      todayButton="Today"
                      dropdownMode="select"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="End date"
                      selected={formik.values.scheduled_end_date}
                      minDate={formik.values.scheduled_start_date ?? null}
                      onChange={(date) =>
                        formik.setFieldValue("scheduled_end_date", date)
                      }
                      customInput={
                        <TextField
                          fullWidth
                          size="small"
                          name="scheduled_end_date"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.scheduled_end_date}
                          error={Boolean(
                            formik.touched.scheduled_end_date &&
                              formik.errors.scheduled_end_date
                          )}
                          helperText={
                            formik.touched.scheduled_end_date &&
                            formik.errors.scheduled_end_date
                          }
                        />
                      }
                    />
                  </Grid>
                  <Grid item xs>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography fontSize={12} variant="h4" fontWeight="700">
                        Notes / Comments
                      </Typography>
                    </Stack>
                    <TextField
                      autoComplete="off"
                      size="small"
                      error={Boolean(
                        formik.touched.notes && formik.errors.notes
                      )}
                      fullWidth
                      helperText={formik.touched.notes && formik.errors.notes}
                      placeholder="Type"
                      margin="normal"
                      sx={{ mt: "8px" }}
                      name="notes"
                      onChange={formik.handleChange}
                      value={formik.values.notes}
                      onBlur={formik.handleBlur}
                      InputProps={{
                        inputComponent: TextareaAutosize,
                        inputProps: { minRows: 4 },
                      }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <Grid item md={4} xs={12} px={{ xs: 0, md: 2 }}>
            <Card sx={{ mt: 2, padding: 2 }} variant="outlined">
              <CardHeader title="Technicians" />
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      id="technicians"
                      size="small"
                      autoComplete="off"
                      error={Boolean(
                        formik.touched.technicians && formik.errors.technicians
                      )}
                      fullWidth
                      helperText={
                        formik.touched.technicians && formik.errors.technicians
                      }
                      placeholder="Add technicians or teams..."
                      margin="normal"
                      name="technicians"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      type="text"
                      value={formik.values.technicians}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        flexGrow: 1,
                      }}
                    ></Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};
